var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg38(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4466_96595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500002H24V24.5H0V0.500002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4466_96595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4297 8.28125C22.9589 9.58466 23.2974 11.0089 23.2974 12.5C23.2974 18.7032 18.2037 23.7969 12.0005 23.7969C9.03522 23.7969 6.33409 22.5967 4.32227 20.7151",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57078 16.7188C1.04161 15.4153 0.703125 13.9911 0.703125 12.5C0.703125 6.29684 5.79684 1.20313 12 1.20313C14.9653 1.20313 17.6664 2.40331 19.6783 4.28488",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 12.5C19.0312 16.3833 15.8833 19.5312 12 19.5312C8.11673 19.5312 4.96875 16.3833 4.96875 12.5C4.96875 8.61673 8.11673 5.46875 12 5.46875C15.8833 5.46875 19.0312 8.61673 19.0312 12.5Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55469 9.6875H18.447",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55469 15.3125H18.447",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 12.5C14.8125 16.3833 13.5533 19.5312 12 19.5312C10.4467 19.5312 9.1875 16.3833 9.1875 12.5C9.1875 8.61673 10.4467 5.46875 12 5.46875C13.5533 5.46875 14.8125 8.61673 14.8125 12.5Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 5.46875C19.0312 6.24538 19.6609 6.875 20.4375 6.875C21.2141 6.875 21.8438 6.24538 21.8438 5.46875C21.8438 4.69212 21.2141 4.0625 20.4375 4.0625C19.6609 4.0625 19.0312 4.69212 19.0312 5.46875Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15625 19.5312C2.15625 20.3079 2.78587 20.9375 3.5625 20.9375C4.33913 20.9375 4.96875 20.3079 4.96875 19.5312C4.96875 18.7546 4.33913 18.125 3.5625 18.125C2.78587 18.125 2.15625 18.7546 2.15625 19.5312Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg38);
export default __webpack_public_path__ + "static/media/38.3b27b769a02764f1f3aab5594ff5521b.svg";
export { ForwardRef as ReactComponent };